import { SessionService } from './../auth/session/session.service';
import { Directive, Input, OnInit, TemplateRef, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[renderingPermissionDirective]'
})
export class RenderingPermissionsDirective implements OnInit {
  @Input('renderingPermissionDirective') requiredGroups: string[];

  constructor(
    private viewContainerRef: ViewContainerRef,
    private templateRef: TemplateRef<any>,
    private sessionService: SessionService
  ) {}

  ngOnInit(): void {
    const groups = this.sessionService.getCurrentSession()?.groups;
    const hasRequiredGroup = this.requiredGroups.some(group => groups?.includes(group));
    if (hasRequiredGroup) {
      this.viewContainerRef.createEmbeddedView(this.templateRef);
    } else {
      this.viewContainerRef.clear();
    }
  }
}
